import React, { useEffect, useState } from 'react';
import axios from '../../axios';
import { Table, Button, Modal, Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

const ManageClasses = () => {
    const { majorId } = useParams();
    const [classes, setClasses] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentClass, setCurrentClass] = useState(null);
    const [formData, setFormData] = useState({
        className: '',
        maxStudents: ''
    });
    const [showDeleteModal, setShowDeleteModal] = useState(false); // State cho modal xóa

    useEffect(() => {
        fetchClasses();
    }, []);

    const fetchClasses = async () => {
        const res = await axios.get(`/majors/${majorId}/classes`);
        setClasses(res.data);
    };

    const handleShowModal = (cls = null) => {
        if (cls) {
            setCurrentClass(cls);
            setFormData({
                className: cls.className,
                maxStudents: cls.maxStudents
            });
        } else {
            setCurrentClass(null);
            setFormData({
                className: '',
                maxStudents: ''
            });
        }
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (currentClass) {
                await axios.put(`/classes/${currentClass._id}`, formData);
            } else {
                await axios.post(`/classes`, { ...formData, majorId });
            }
            fetchClasses();
            handleCloseModal();
        } catch (err) {
            console.error(err);
        }
    };

    const handleDeleteConfirm = (cls) => {
        setCurrentClass(cls);
        setShowDeleteModal(true);
    };

    const handleDelete = async () => {
        try {
            await axios.delete(`/classes/${currentClass._id}`);
            fetchClasses();
            setShowDeleteModal(false);
        } catch (err) {
            console.error(err);
        }
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    return (
        <div>
            <h2>Manage Classes for Major</h2>
            <Button variant="primary" onClick={() => handleShowModal()}>Add Class</Button>
            <Table striped bordered hover className="mt-3">
                <thead>
                    <tr>
                        <th>Class Name</th>
                        <th>Max Students</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {classes.map(cls => (
                        <tr key={cls._id}>
                            <td>{cls.className}</td>
                            <td>{cls.maxStudents}</td>
                            <td>
                                <Button variant="info" onClick={() => handleShowModal(cls)} className="mr-2">Edit</Button>
                                <Button variant="danger" onClick={() => handleDeleteConfirm(cls)}>Delete</Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {/* Modal để thêm/sửa lớp */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{currentClass ? 'Edit Class' : 'Add Class'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formClassName">
                            <Form.Label>Class Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="className"
                                value={formData.className}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formMaxStudents">
                            <Form.Label>Max Students</Form.Label>
                            <Form.Control
                                type="number"
                                name="maxStudents"
                                value={formData.maxStudents}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit">
                            {currentClass ? 'Update Class' : 'Add Class'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Modal xác nhận xóa */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete the class <strong>{currentClass && currentClass.className}</strong>?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ManageClasses;
